module.exports = __webpack_public_path__ + "img/cab_sg.485879d5.jpg";